import React, { createContext, useContext } from 'react'

interface AnalyticsScreenShareContextValue {
    isActive: boolean
    zoom: number
}

const AnalyticsScreenShareContext = createContext<AnalyticsScreenShareContextValue>({
    isActive: false,
    zoom: 1,
})

interface AnalyticsScreenShareProviderProps {
    value: AnalyticsScreenShareContextValue
    children: React.ReactNode
}

export function AnalyticsScreenShareProvider(props: AnalyticsScreenShareProviderProps) {
    const { value, children } = props
    return (
        <AnalyticsScreenShareContext.Provider value={value}>
            {children}
        </AnalyticsScreenShareContext.Provider>
    )
}

export function useAnalyticsScreenShare() {
    return useContext(AnalyticsScreenShareContext)
}
